
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      images: [],
      titles: [],
      titleUrls: [],
      sourceButtons: [],
      imageTags: [],
      currentImageIndex: 0,
      closed: true,
      handlers: {},
      thumbnails: false,

      // VueSlickCarousel setting: https://gs-shop.github.io/vue-slick-carousel/#/api
      settings: {
        centerMode: true,
        variableWidth: true,
        accessibility: true,
        speed: 400,
      },
    };
  },
  watch: {
    closed(newVal) {
      if (newVal && this.handlers.closed) {
        this.handlers.closed();
      }
      if (!newVal && this.handlers.opened) {
        this.$refs?.slick?.goTo(this.currentImageIndex, true);
        this.handlers.opened();
      }
    },
  },
  mounted() {
    this.setSlickProps();
    // Use typeof window !== 'undefined' check for client-side execution
    if (typeof window !== "undefined") {
      window.addEventListener("keyup", this.handleKeyUp);
    }
  },
  beforeDestroy() {
    // Use typeof window !== 'undefined' check for client-side execution
    if (typeof window !== "undefined") {
      window.removeEventListener("keyup", this.handleKeyUp);
    }
  },
  methods: {
    slickInited() {
      this.$nextTick(() => {
        this.$refs?.slick?.goTo(this.currentImageIndex, true);
        this.setSlickProps();
        if (this.$refs?.slick?.$refs && this.$refs?.slick?.$refs?.innerSlider) {
          this.$refs.slick.$refs.innerSlider.$props.verticalSwiping = true;
        }
      });
    },

    setSlickProps() {
      if (window.innerWidth < 768) {
        this.settings.vertical = true;
        this.settings.swipeToSlide = true;
      }
    },

    fireChangeEvent() {
      if (this.handlers.changed) {
        this.handlers.changed(this.currentImageIndex);
      }
    },

    close() {
      if (!this.closed) {
        document.querySelector("body").classList.remove("body-fs-v-img");
        this.images = [];
        this.currentImageIndex = 0;
        this.closed = true;
      }
    },

    next() {
      if (!this.closed && this.images.length > 1) {
        // if next index not exists in array of images, set index to first element
        if (this.currentImageIndex + 1 < this.images.length) {
          this.currentImageIndex++;
        } else {
          this.currentImageIndex = 0;
        }
        this.$refs?.slick?.next();
        this.fireChangeEvent();
      }
    },

    select(selectedImage) {
      this.currentImageIndex = selectedImage;
      this.$refs?.slick?.goTo(selectedImage);
      this.fireChangeEvent();
    },

    prev() {
      if (!this.closed && this.images.length > 1) {
        // if prev index not exists in array of images, set index to last element
        if (this.currentImageIndex > 0) {
          this.currentImageIndex--;
        } else {
          this.currentImageIndex = this.images.length - 1;
        }
        this.$refs?.slick?.prev();
        this.fireChangeEvent();
      }
    },

    handleKeyUp(e) {
      // esc key and 'q' for quit
      if (e.key === "Escape" || e.key === "q") this.close();
      // arrow right and 'l' key (vim-like binding)
      if (e.key === "ArrowRight" || e.key === "l") this.next();
      // // arrow left and 'h' key (vim-like binding)
      if (e.key === "ArrowLeft" || e.key === "h") this.prev();
    },
  },
};
